module.exports = __webpack_public_path__ + "img/S.e925d60e.webp";